module.exports = {
	"contractName": "PostingStore",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "amountOfTokensForQuerying",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_postingDetails",
					"type": "bytes32"
				}
			],
			"name": "getPostingWhenTrue",
			"outputs": [
				{
					"name": "",
					"type": "address[]"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_details",
					"type": "bytes32"
				}
			],
			"name": "addPostings",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "amountOfTokensForPosting",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "echoLinkFoundation",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "postingSetToFalse",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "bytes32"
				},
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "credentialIdsByStatus",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "postingDetails",
					"type": "bytes32"
				}
			],
			"name": "queryPosting",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_amountOfTokensForPosting",
					"type": "uint256"
				},
				{
					"name": "_amountOfTokensForQuerying",
					"type": "uint256"
				}
			],
			"name": "setNumberOfTokens",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "addr",
					"type": "address"
				}
			],
			"name": "approveToAddPostings",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "echoLinktokenContractAddress",
					"type": "address"
				},
				{
					"name": "_echoLinkFoundation",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "_sender",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_details",
					"type": "bytes32"
				}
			],
			"name": "PostingAdded",
			"type": "event"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "106:3545:5:-;;;991:220;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;216:10:4;208:5;;:18;;;;;;;;;;;;;;;;;;1125:28:5;1097:11;;:57;;;;;;;;;;;;;;;;;;1185:19;1164:18;;:40;;;;;;;;;;;;;;;;;;991:220;;106:3545;;;;;;",
	"deployedSourceMap": "106:3545:5:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;842:40;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3337:181;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:2;8:100;;;99:1;94:3;90;84:5;80:1;75:3;71;64:6;52:2;49:1;45:3;40:15;;8:100;;;12:14;3:109;;;;;;;;;;;;;;;;;1782:398:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;;797:39;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;72:20:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;219:33:5;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3524:124;;;;;;;;;;;;;;331:56;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2217:1110;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1256:255;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1569:176;;;;;;;;;;;;;;;;;;;;;;;;;;;;255:121:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;842:40:5;;;;:::o;3337:181::-;3410:9;;:::i;:::-;3438:10;:22;3449:10;3438:22;;;;;;;;;;;;;;;;;;;;;;;;;3430:31;;;;;;;;3478:15;:32;3494:15;3478:32;;;;;;;;;;;;;;;;;3471:40;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3337:181;;;:::o;1782:398::-;1846:19;:31;1866:10;1846:31;;;;;;;;;;;;;;;;;;;;;;;;;:64;;;;;1909:1;1881:24;;:29;;1846:64;:98;;;;;1943:1;1914:25;;:30;;1846:98;1838:107;;;;;;;;1955:11;;;;;;;;;;;:24;;;1980:10;1992:18;;;;;;;;;;;2012:24;;1955:82;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2087:15;:25;2103:8;2087:25;;;;;;;;;;;;;;;;;:42;;;;;;;;;;;:::i;:::-;;;;;;;;;;2118:10;2087:42;;;;;;;;;;;;;;;;;;;;;;;2139:34;2152:10;2164:8;2139:34;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1782:398;:::o;797:39::-;;;;:::o;72:20:4:-;;;;;;;;;;;;;:::o;219:33:5:-;;;;;;;;;;;;;:::o;3524:124::-;3578:10;:22;3589:10;3578:22;;;;;;;;;;;;;;;;;;;;;;;;;3570:31;;;;;;;;3636:5;3611:10;:22;3622:10;3611:22;;;;;;;;;;;;;;;;:30;;;;;;;;;;;;;;;;;;3524:124::o;331:56::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;2217:1110::-;2361:30;;:::i;:::-;2457:14;2813:22;3077:18;3184:9;2315:1;2287:24;;:29;;:63;;;;;2349:1;2320:25;;:30;;2287:63;2279:72;;;;;;;;2416:15;:31;2432:14;2416:31;;;;;;;;;;;;;;;;;2401:46;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2474:12;:19;2457:36;;2595:1;2585:6;:11;2582:739;;;2611:11;;;;;;;;;;;:24;;;2636:10;2648:18;;;;;;;;;;;2668:25;;2611:83;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2582:739;;;2866:1;2838:25;;:29;;;;;;;;2813:54;;2881:11;;;;;;;;;;;:24;;;2906:10;2918:18;;;;;;;;;;;2938:14;2881:72;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2992:4;2967:10;:22;2978:10;2967:22;;;;;;;;;;;;;;;;:29;;;;;;;;;;;;;;;;;;3113:6;3098:14;:21;;;;;;;;3077:42;;3194:1;3184:11;;3180:131;3201:6;3197:1;:10;3180:131;;;3231:11;;;;;;;;;;;:24;;;3256:10;3268:12;3281:1;3268:15;;;;;;;;;;;;;;;;;;3285:10;3231:65;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3209:3;;;;;;;3180:131;;;2582:739;2217:1110;;;;;;:::o;1256:255::-;1425:6;1397:25;:34;1370:24;:61;;;;1498:6;1469:26;:35;1441:25;:63;;;;1256:255;;:::o;1569:176::-;152:5:4;;;;;;;;;;;138:19;;:10;:19;;;130:28;;;;;;;;1663:1:5;1647:18;;:4;:18;;;;:48;;;;;1670:19;:25;1690:4;1670:25;;;;;;;;;;;;;;;;;;;;;;;;;1669:26;1647:48;1639:57;;;;;;;;1734:4;1706:19;:25;1726:4;1706:25;;;;;;;;;;;;;;;;:32;;;;;;;;;;;;;;;;;;1569:176;:::o;255:121:4:-;152:5;;;;;;;;;;;138:19;;:10;:19;;;130:28;;;;;;;;349:1;329:22;;:8;:22;;;;321:31;;;;;;;;364:8;356:5;;:16;;;;;;;;;;;;;;;;;;255:121;:::o;106:3545:5:-;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.16;\n\nimport './EchoLinkToken.sol';\nimport './SafeMath.sol';\nimport './Ownable.sol';\n\ncontract PostingStore is Ownable{\n    \n    using SafeMath for uint256;\n\n    //address of _echoLinkFoundation\n    address public echoLinkFoundation;\n\n    //object for token contract\n    EchoLinkToken private objEchoLink;\n\n    mapping (bytes32 => uint[]) public credentialIdsByStatus;\n\n    //mapping to store approved user for posting\n    mapping (address => bool) private approvedForPostings;\n    //mapping to store address corrresponding to the details of posting\n    mapping (bytes32 => address[]) private retrievePosting;\n    //mapping to set posting when result fetched\n    mapping (address => bool) private postingSet;\n    //set number of tokens to be givem for querying and posting\n    uint256 public amountOfTokensForPosting;\n    uint256 public amountOfTokensForQuerying;\n\n    //fire when approved user add posting\n    event PostingAdded(address _sender, bytes32 _details);\n\n    function PostingStore(address echoLinktokenContractAddress, address _echoLinkFoundation) public {\n        objEchoLink = EchoLinkToken(echoLinktokenContractAddress);\n        echoLinkFoundation = _echoLinkFoundation;\n    }\n\n    //function to set number of tokens\n    function setNumberOfTokens(uint256 _amountOfTokensForPosting, uint256 _amountOfTokensForQuerying) public{\n        amountOfTokensForPosting = _amountOfTokensForPosting * 10**18;\n        amountOfTokensForQuerying = _amountOfTokensForQuerying * 10**18;\n    }\n\n    //function to approve recruiter to add postings\n    function approveToAddPostings(address addr) public onlyOwner{\n        require(addr != address(0) && !approvedForPostings[addr]);\n        approvedForPostings[addr] = true;\n    }\n\n    //function to add postings\n    function addPostings (bytes32 _details) public{\n        require(approvedForPostings[msg.sender] && amountOfTokensForPosting != 0 && amountOfTokensForQuerying != 0);\n        objEchoLink.transferFrom(msg.sender, echoLinkFoundation, amountOfTokensForPosting);\n        //posting is added by recruiter\n        retrievePosting[_details].push(msg.sender);\n        PostingAdded(msg.sender, _details);\n    }\n\n    //search based on postings\n    function queryPosting(bytes32 postingDetails) public{\n        require(amountOfTokensForPosting != 0 && amountOfTokensForQuerying != 0);\n        address [] memory arrayPosting;\n        arrayPosting = retrievePosting[postingDetails];\n        uint256 length = arrayPosting.length;     \n        //length of array is 0, transfer all tokens to echoLinkFoundation\n        if(length == 0){\n            objEchoLink.transferFrom(msg.sender, echoLinkFoundation, amountOfTokensForQuerying);\n            \n        }\n        //length != 0, transfer equal amount of tokens to recruiter\n        else{\n            uint256 amountTokenPay = amountOfTokensForQuerying / 2;\n            objEchoLink.transferFrom(msg.sender, echoLinkFoundation, amountTokenPay);\n            postingSet[msg.sender] = true;\n            //calculate equal amount of token to give to recruiter\n            uint256 equalToken = amountTokenPay/length;\n            //transfer token to each recruiter\n            for(uint256 j=0; j < length; j++){\n                objEchoLink.transferFrom(msg.sender, arrayPosting[j], equalToken);\n            }\n        }\n    }\n    \n    function getPostingWhenTrue(bytes32 _postingDetails) public view returns(address[]){\n        require(postingSet[msg.sender]);\n        return(retrievePosting[_postingDetails]);\n    }\n\n    function postingSetToFalse() public {\n        require(postingSet[msg.sender]);\n        postingSet[msg.sender] = false;\n    }\n\n}",
	"sourcePath": "/Users/sarthak/dltlabs/echolink-code/contracts/PostingStore.sol",
	"ast": {
		"attributes": {
			"absolutePath": "/Users/sarthak/dltlabs/echolink-code/contracts/PostingStore.sol",
			"exportedSymbols": {
				"PostingStore": [
					1867
				]
			}
		},
		"children": [
			{
				"attributes": {
					"literals": [
						"solidity",
						"^",
						"0.4",
						".16"
					]
				},
				"id": 1576,
				"name": "PragmaDirective",
				"src": "0:24:5"
			},
			{
				"attributes": {
					"SourceUnit": 1027,
					"absolutePath": "/Users/sarthak/dltlabs/echolink-code/contracts/EchoLinkToken.sol",
					"file": "./EchoLinkToken.sol",
					"scope": 1868,
					"symbolAliases": [
						null
					],
					"unitAlias": ""
				},
				"id": 1577,
				"name": "ImportDirective",
				"src": "26:29:5"
			},
			{
				"attributes": {
					"SourceUnit": 1963,
					"absolutePath": "/Users/sarthak/dltlabs/echolink-code/contracts/SafeMath.sol",
					"file": "./SafeMath.sol",
					"scope": 1868,
					"symbolAliases": [
						null
					],
					"unitAlias": ""
				},
				"id": 1578,
				"name": "ImportDirective",
				"src": "56:24:5"
			},
			{
				"attributes": {
					"SourceUnit": 1575,
					"absolutePath": "/Users/sarthak/dltlabs/echolink-code/contracts/Ownable.sol",
					"file": "./Ownable.sol",
					"scope": 1868,
					"symbolAliases": [
						null
					],
					"unitAlias": ""
				},
				"id": 1579,
				"name": "ImportDirective",
				"src": "81:23:5"
			},
			{
				"attributes": {
					"contractDependencies": [
						1574
					],
					"contractKind": "contract",
					"documentation": null,
					"fullyImplemented": true,
					"linearizedBaseContracts": [
						1867,
						1574
					],
					"name": "PostingStore",
					"scope": 1868
				},
				"children": [
					{
						"attributes": {
							"arguments": [
								null
							]
						},
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "Ownable",
									"referencedDeclaration": 1574,
									"type": "contract Ownable"
								},
								"id": 1580,
								"name": "UserDefinedTypeName",
								"src": "131:7:5"
							}
						],
						"id": 1581,
						"name": "InheritanceSpecifier",
						"src": "131:7:5"
					},
					{
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "SafeMath",
									"referencedDeclaration": 1962,
									"type": "library SafeMath"
								},
								"id": 1582,
								"name": "UserDefinedTypeName",
								"src": "155:8:5"
							},
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 1583,
								"name": "ElementaryTypeName",
								"src": "168:7:5"
							}
						],
						"id": 1584,
						"name": "UsingForDirective",
						"src": "149:27:5"
					},
					{
						"attributes": {
							"constant": false,
							"name": "echoLinkFoundation",
							"scope": 1867,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "address",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "address",
									"type": "address"
								},
								"id": 1585,
								"name": "ElementaryTypeName",
								"src": "219:7:5"
							}
						],
						"id": 1586,
						"name": "VariableDeclaration",
						"src": "219:33:5"
					},
					{
						"attributes": {
							"constant": false,
							"name": "objEchoLink",
							"scope": 1867,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "contract EchoLinkToken",
							"value": null,
							"visibility": "private"
						},
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "EchoLinkToken",
									"referencedDeclaration": 1026,
									"type": "contract EchoLinkToken"
								},
								"id": 1587,
								"name": "UserDefinedTypeName",
								"src": "291:13:5"
							}
						],
						"id": 1588,
						"name": "VariableDeclaration",
						"src": "291:33:5"
					},
					{
						"attributes": {
							"constant": false,
							"name": "credentialIdsByStatus",
							"scope": 1867,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(bytes32 => uint256[] storage ref)",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(bytes32 => uint256[] storage ref)"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes32",
											"type": "bytes32"
										},
										"id": 1589,
										"name": "ElementaryTypeName",
										"src": "340:7:5"
									},
									{
										"attributes": {
											"length": null,
											"type": "uint256[] storage pointer"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 1590,
												"name": "ElementaryTypeName",
												"src": "351:4:5"
											}
										],
										"id": 1591,
										"name": "ArrayTypeName",
										"src": "351:6:5"
									}
								],
								"id": 1592,
								"name": "Mapping",
								"src": "331:27:5"
							}
						],
						"id": 1593,
						"name": "VariableDeclaration",
						"src": "331:56:5"
					},
					{
						"attributes": {
							"constant": false,
							"name": "approvedForPostings",
							"scope": 1867,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(address => bool)",
							"value": null,
							"visibility": "private"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(address => bool)"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 1594,
										"name": "ElementaryTypeName",
										"src": "452:7:5"
									},
									{
										"attributes": {
											"name": "bool",
											"type": "bool"
										},
										"id": 1595,
										"name": "ElementaryTypeName",
										"src": "463:4:5"
									}
								],
								"id": 1596,
								"name": "Mapping",
								"src": "443:25:5"
							}
						],
						"id": 1597,
						"name": "VariableDeclaration",
						"src": "443:53:5"
					},
					{
						"attributes": {
							"constant": false,
							"name": "retrievePosting",
							"scope": 1867,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(bytes32 => address[] storage ref)",
							"value": null,
							"visibility": "private"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(bytes32 => address[] storage ref)"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes32",
											"type": "bytes32"
										},
										"id": 1598,
										"name": "ElementaryTypeName",
										"src": "583:7:5"
									},
									{
										"attributes": {
											"length": null,
											"type": "address[] storage pointer"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1599,
												"name": "ElementaryTypeName",
												"src": "594:7:5"
											}
										],
										"id": 1600,
										"name": "ArrayTypeName",
										"src": "594:9:5"
									}
								],
								"id": 1601,
								"name": "Mapping",
								"src": "574:30:5"
							}
						],
						"id": 1602,
						"name": "VariableDeclaration",
						"src": "574:54:5"
					},
					{
						"attributes": {
							"constant": false,
							"name": "postingSet",
							"scope": 1867,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(address => bool)",
							"value": null,
							"visibility": "private"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(address => bool)"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 1603,
										"name": "ElementaryTypeName",
										"src": "692:7:5"
									},
									{
										"attributes": {
											"name": "bool",
											"type": "bool"
										},
										"id": 1604,
										"name": "ElementaryTypeName",
										"src": "703:4:5"
									}
								],
								"id": 1605,
								"name": "Mapping",
								"src": "683:25:5"
							}
						],
						"id": 1606,
						"name": "VariableDeclaration",
						"src": "683:44:5"
					},
					{
						"attributes": {
							"constant": false,
							"name": "amountOfTokensForPosting",
							"scope": 1867,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 1607,
								"name": "ElementaryTypeName",
								"src": "797:7:5"
							}
						],
						"id": 1608,
						"name": "VariableDeclaration",
						"src": "797:39:5"
					},
					{
						"attributes": {
							"constant": false,
							"name": "amountOfTokensForQuerying",
							"scope": 1867,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 1609,
								"name": "ElementaryTypeName",
								"src": "842:7:5"
							}
						],
						"id": 1610,
						"name": "VariableDeclaration",
						"src": "842:40:5"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "PostingAdded"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_sender",
											"scope": 1616,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1611,
												"name": "ElementaryTypeName",
												"src": "950:7:5"
											}
										],
										"id": 1612,
										"name": "VariableDeclaration",
										"src": "950:15:5"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_details",
											"scope": 1616,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 1613,
												"name": "ElementaryTypeName",
												"src": "967:7:5"
											}
										],
										"id": 1614,
										"name": "VariableDeclaration",
										"src": "967:16:5"
									}
								],
								"id": 1615,
								"name": "ParameterList",
								"src": "949:35:5"
							}
						],
						"id": 1616,
						"name": "EventDefinition",
						"src": "931:54:5"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": true,
							"modifiers": [
								null
							],
							"name": "PostingStore",
							"payable": false,
							"scope": 1867,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "echoLinktokenContractAddress",
											"scope": 1634,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1617,
												"name": "ElementaryTypeName",
												"src": "1013:7:5"
											}
										],
										"id": 1618,
										"name": "VariableDeclaration",
										"src": "1013:36:5"
									},
									{
										"attributes": {
											"constant": false,
											"name": "_echoLinkFoundation",
											"scope": 1634,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1619,
												"name": "ElementaryTypeName",
												"src": "1051:7:5"
											}
										],
										"id": 1620,
										"name": "VariableDeclaration",
										"src": "1051:27:5"
									}
								],
								"id": 1621,
								"name": "ParameterList",
								"src": "1012:67:5"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1622,
								"name": "ParameterList",
								"src": "1087:0:5"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "contract EchoLinkToken"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1588,
															"type": "contract EchoLinkToken",
															"value": "objEchoLink"
														},
														"id": 1623,
														"name": "Identifier",
														"src": "1097:11:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "contract EchoLinkToken",
															"type_conversion": true
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	],
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1026,
																	"type": "type(contract EchoLinkToken)",
																	"value": "EchoLinkToken"
																},
																"id": 1624,
																"name": "Identifier",
																"src": "1111:13:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1618,
																	"type": "address",
																	"value": "echoLinktokenContractAddress"
																},
																"id": 1625,
																"name": "Identifier",
																"src": "1125:28:5"
															}
														],
														"id": 1626,
														"name": "FunctionCall",
														"src": "1111:43:5"
													}
												],
												"id": 1627,
												"name": "Assignment",
												"src": "1097:57:5"
											}
										],
										"id": 1628,
										"name": "ExpressionStatement",
										"src": "1097:57:5"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1586,
															"type": "address",
															"value": "echoLinkFoundation"
														},
														"id": 1629,
														"name": "Identifier",
														"src": "1164:18:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1620,
															"type": "address",
															"value": "_echoLinkFoundation"
														},
														"id": 1630,
														"name": "Identifier",
														"src": "1185:19:5"
													}
												],
												"id": 1631,
												"name": "Assignment",
												"src": "1164:40:5"
											}
										],
										"id": 1632,
										"name": "ExpressionStatement",
										"src": "1164:40:5"
									}
								],
								"id": 1633,
								"name": "Block",
								"src": "1087:124:5"
							}
						],
						"id": 1634,
						"name": "FunctionDefinition",
						"src": "991:220:5"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "setNumberOfTokens",
							"payable": false,
							"scope": 1867,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_amountOfTokensForPosting",
											"scope": 1658,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1635,
												"name": "ElementaryTypeName",
												"src": "1283:7:5"
											}
										],
										"id": 1636,
										"name": "VariableDeclaration",
										"src": "1283:33:5"
									},
									{
										"attributes": {
											"constant": false,
											"name": "_amountOfTokensForQuerying",
											"scope": 1658,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1637,
												"name": "ElementaryTypeName",
												"src": "1318:7:5"
											}
										],
										"id": 1638,
										"name": "VariableDeclaration",
										"src": "1318:34:5"
									}
								],
								"id": 1639,
								"name": "ParameterList",
								"src": "1282:71:5"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1640,
								"name": "ParameterList",
								"src": "1360:0:5"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1608,
															"type": "uint256",
															"value": "amountOfTokensForPosting"
														},
														"id": 1641,
														"name": "Identifier",
														"src": "1370:24:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "*",
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1636,
																	"type": "uint256",
																	"value": "_amountOfTokensForPosting"
																},
																"id": 1642,
																"name": "Identifier",
																"src": "1397:25:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_rational_1000000000000000000_by_1",
																		"typeString": "int_const 1000000000000000000"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"operator": "**",
																	"type": "int_const 1000000000000000000"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "3130",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 10",
																			"value": "10"
																		},
																		"id": 1643,
																		"name": "Literal",
																		"src": "1425:2:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "3138",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 18",
																			"value": "18"
																		},
																		"id": 1644,
																		"name": "Literal",
																		"src": "1429:2:5"
																	}
																],
																"id": 1645,
																"name": "BinaryOperation",
																"src": "1425:6:5"
															}
														],
														"id": 1646,
														"name": "BinaryOperation",
														"src": "1397:34:5"
													}
												],
												"id": 1647,
												"name": "Assignment",
												"src": "1370:61:5"
											}
										],
										"id": 1648,
										"name": "ExpressionStatement",
										"src": "1370:61:5"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1610,
															"type": "uint256",
															"value": "amountOfTokensForQuerying"
														},
														"id": 1649,
														"name": "Identifier",
														"src": "1441:25:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "*",
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1638,
																	"type": "uint256",
																	"value": "_amountOfTokensForQuerying"
																},
																"id": 1650,
																"name": "Identifier",
																"src": "1469:26:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_rational_1000000000000000000_by_1",
																		"typeString": "int_const 1000000000000000000"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"operator": "**",
																	"type": "int_const 1000000000000000000"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "3130",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 10",
																			"value": "10"
																		},
																		"id": 1651,
																		"name": "Literal",
																		"src": "1498:2:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "3138",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 18",
																			"value": "18"
																		},
																		"id": 1652,
																		"name": "Literal",
																		"src": "1502:2:5"
																	}
																],
																"id": 1653,
																"name": "BinaryOperation",
																"src": "1498:6:5"
															}
														],
														"id": 1654,
														"name": "BinaryOperation",
														"src": "1469:35:5"
													}
												],
												"id": 1655,
												"name": "Assignment",
												"src": "1441:63:5"
											}
										],
										"id": 1656,
										"name": "ExpressionStatement",
										"src": "1441:63:5"
									}
								],
								"id": 1657,
								"name": "Block",
								"src": "1360:151:5"
							}
						],
						"id": 1658,
						"name": "FunctionDefinition",
						"src": "1256:255:5"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "approveToAddPostings",
							"payable": false,
							"scope": 1867,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "addr",
											"scope": 1685,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1659,
												"name": "ElementaryTypeName",
												"src": "1599:7:5"
											}
										],
										"id": 1660,
										"name": "VariableDeclaration",
										"src": "1599:12:5"
									}
								],
								"id": 1661,
								"name": "ParameterList",
								"src": "1598:14:5"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1664,
								"name": "ParameterList",
								"src": "1629:0:5"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 1544,
											"type": "modifier ()",
											"value": "onlyOwner"
										},
										"id": 1662,
										"name": "Identifier",
										"src": "1620:9:5"
									}
								],
								"id": 1663,
								"name": "ModifierInvocation",
								"src": "1620:9:5"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1665,
														"name": "Identifier",
														"src": "1639:7:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1660,
																			"type": "address",
																			"value": "addr"
																		},
																		"id": 1666,
																		"name": "Identifier",
																		"src": "1647:4:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"isStructConstructorCall": false,
																			"lValueRequested": false,
																			"names": [
																				null
																			],
																			"type": "address",
																			"type_conversion": true
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": [
																						{
																							"typeIdentifier": "t_rational_0_by_1",
																							"typeString": "int_const 0"
																						}
																					],
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"type": "type(address)",
																					"value": "address"
																				},
																				"id": 1667,
																				"name": "ElementaryTypeNameExpression",
																				"src": "1655:7:5"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"hexvalue": "30",
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"subdenomination": null,
																					"token": "number",
																					"type": "int_const 0",
																					"value": "0"
																				},
																				"id": 1668,
																				"name": "Literal",
																				"src": "1663:1:5"
																			}
																		],
																		"id": 1669,
																		"name": "FunctionCall",
																		"src": "1655:10:5"
																	}
																],
																"id": 1670,
																"name": "BinaryOperation",
																"src": "1647:18:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!",
																	"prefix": true,
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1597,
																					"type": "mapping(address => bool)",
																					"value": "approvedForPostings"
																				},
																				"id": 1671,
																				"name": "Identifier",
																				"src": "1670:19:5"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1660,
																					"type": "address",
																					"value": "addr"
																				},
																				"id": 1672,
																				"name": "Identifier",
																				"src": "1690:4:5"
																			}
																		],
																		"id": 1673,
																		"name": "IndexAccess",
																		"src": "1670:25:5"
																	}
																],
																"id": 1674,
																"name": "UnaryOperation",
																"src": "1669:26:5"
															}
														],
														"id": 1675,
														"name": "BinaryOperation",
														"src": "1647:48:5"
													}
												],
												"id": 1676,
												"name": "FunctionCall",
												"src": "1639:57:5"
											}
										],
										"id": 1677,
										"name": "ExpressionStatement",
										"src": "1639:57:5"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1597,
																	"type": "mapping(address => bool)",
																	"value": "approvedForPostings"
																},
																"id": 1678,
																"name": "Identifier",
																"src": "1706:19:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1660,
																	"type": "address",
																	"value": "addr"
																},
																"id": 1679,
																"name": "Identifier",
																"src": "1726:4:5"
															}
														],
														"id": 1680,
														"name": "IndexAccess",
														"src": "1706:25:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "74727565",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "bool",
															"type": "bool",
															"value": "true"
														},
														"id": 1681,
														"name": "Literal",
														"src": "1734:4:5"
													}
												],
												"id": 1682,
												"name": "Assignment",
												"src": "1706:32:5"
											}
										],
										"id": 1683,
										"name": "ExpressionStatement",
										"src": "1706:32:5"
									}
								],
								"id": 1684,
								"name": "Block",
								"src": "1629:116:5"
							}
						],
						"id": 1685,
						"name": "FunctionDefinition",
						"src": "1569:176:5"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "addPostings",
							"payable": false,
							"scope": 1867,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_details",
											"scope": 1729,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 1686,
												"name": "ElementaryTypeName",
												"src": "1804:7:5"
											}
										],
										"id": 1687,
										"name": "VariableDeclaration",
										"src": "1804:16:5"
									}
								],
								"id": 1688,
								"name": "ParameterList",
								"src": "1803:18:5"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1689,
								"name": "ParameterList",
								"src": "1828:0:5"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1690,
														"name": "Identifier",
														"src": "1838:7:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "&&",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1597,
																					"type": "mapping(address => bool)",
																					"value": "approvedForPostings"
																				},
																				"id": 1691,
																				"name": "Identifier",
																				"src": "1846:19:5"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "sender",
																					"referencedDeclaration": null,
																					"type": "address"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1974,
																							"type": "msg",
																							"value": "msg"
																						},
																						"id": 1692,
																						"name": "Identifier",
																						"src": "1866:3:5"
																					}
																				],
																				"id": 1693,
																				"name": "MemberAccess",
																				"src": "1866:10:5"
																			}
																		],
																		"id": 1694,
																		"name": "IndexAccess",
																		"src": "1846:31:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			},
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"operator": "!=",
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1608,
																					"type": "uint256",
																					"value": "amountOfTokensForPosting"
																				},
																				"id": 1695,
																				"name": "Identifier",
																				"src": "1881:24:5"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"hexvalue": "30",
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"subdenomination": null,
																					"token": "number",
																					"type": "int_const 0",
																					"value": "0"
																				},
																				"id": 1696,
																				"name": "Literal",
																				"src": "1909:1:5"
																			}
																		],
																		"id": 1697,
																		"name": "BinaryOperation",
																		"src": "1881:29:5"
																	}
																],
																"id": 1698,
																"name": "BinaryOperation",
																"src": "1846:64:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1610,
																			"type": "uint256",
																			"value": "amountOfTokensForQuerying"
																		},
																		"id": 1699,
																		"name": "Identifier",
																		"src": "1914:25:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 1700,
																		"name": "Literal",
																		"src": "1943:1:5"
																	}
																],
																"id": 1701,
																"name": "BinaryOperation",
																"src": "1914:30:5"
															}
														],
														"id": 1702,
														"name": "BinaryOperation",
														"src": "1846:98:5"
													}
												],
												"id": 1703,
												"name": "FunctionCall",
												"src": "1838:107:5"
											}
										],
										"id": 1704,
										"name": "ExpressionStatement",
										"src": "1838:107:5"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "bool",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "transferFrom",
															"referencedDeclaration": 442,
															"type": "function (address,address,uint256) external returns (bool)"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1588,
																	"type": "contract EchoLinkToken",
																	"value": "objEchoLink"
																},
																"id": 1705,
																"name": "Identifier",
																"src": "1955:11:5"
															}
														],
														"id": 1707,
														"name": "MemberAccess",
														"src": "1955:24:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1974,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 1708,
																"name": "Identifier",
																"src": "1980:3:5"
															}
														],
														"id": 1709,
														"name": "MemberAccess",
														"src": "1980:10:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1586,
															"type": "address",
															"value": "echoLinkFoundation"
														},
														"id": 1710,
														"name": "Identifier",
														"src": "1992:18:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1608,
															"type": "uint256",
															"value": "amountOfTokensForPosting"
														},
														"id": 1711,
														"name": "Identifier",
														"src": "2012:24:5"
													}
												],
												"id": 1712,
												"name": "FunctionCall",
												"src": "1955:82:5"
											}
										],
										"id": 1713,
										"name": "ExpressionStatement",
										"src": "1955:82:5"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "uint256",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "push",
															"referencedDeclaration": null,
															"type": "function (address) returns (uint256)"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "address[] storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1602,
																			"type": "mapping(bytes32 => address[] storage ref)",
																			"value": "retrievePosting"
																		},
																		"id": 1714,
																		"name": "Identifier",
																		"src": "2087:15:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1687,
																			"type": "bytes32",
																			"value": "_details"
																		},
																		"id": 1715,
																		"name": "Identifier",
																		"src": "2103:8:5"
																	}
																],
																"id": 1716,
																"name": "IndexAccess",
																"src": "2087:25:5"
															}
														],
														"id": 1717,
														"name": "MemberAccess",
														"src": "2087:30:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1974,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 1718,
																"name": "Identifier",
																"src": "2118:3:5"
															}
														],
														"id": 1719,
														"name": "MemberAccess",
														"src": "2118:10:5"
													}
												],
												"id": 1720,
												"name": "FunctionCall",
												"src": "2087:42:5"
											}
										],
										"id": 1721,
										"name": "ExpressionStatement",
										"src": "2087:42:5"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1616,
															"type": "function (address,bytes32)",
															"value": "PostingAdded"
														},
														"id": 1722,
														"name": "Identifier",
														"src": "2139:12:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1974,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 1723,
																"name": "Identifier",
																"src": "2152:3:5"
															}
														],
														"id": 1724,
														"name": "MemberAccess",
														"src": "2152:10:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1687,
															"type": "bytes32",
															"value": "_details"
														},
														"id": 1725,
														"name": "Identifier",
														"src": "2164:8:5"
													}
												],
												"id": 1726,
												"name": "FunctionCall",
												"src": "2139:34:5"
											}
										],
										"id": 1727,
										"name": "ExpressionStatement",
										"src": "2139:34:5"
									}
								],
								"id": 1728,
								"name": "Block",
								"src": "1828:352:5"
							}
						],
						"id": 1729,
						"name": "FunctionDefinition",
						"src": "1782:398:5"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "queryPosting",
							"payable": false,
							"scope": 1867,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "postingDetails",
											"scope": 1827,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 1730,
												"name": "ElementaryTypeName",
												"src": "2239:7:5"
											}
										],
										"id": 1731,
										"name": "VariableDeclaration",
										"src": "2239:22:5"
									}
								],
								"id": 1732,
								"name": "ParameterList",
								"src": "2238:24:5"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1733,
								"name": "ParameterList",
								"src": "2269:0:5"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1734,
														"name": "Identifier",
														"src": "2279:7:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1608,
																			"type": "uint256",
																			"value": "amountOfTokensForPosting"
																		},
																		"id": 1735,
																		"name": "Identifier",
																		"src": "2287:24:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 1736,
																		"name": "Literal",
																		"src": "2315:1:5"
																	}
																],
																"id": 1737,
																"name": "BinaryOperation",
																"src": "2287:29:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1610,
																			"type": "uint256",
																			"value": "amountOfTokensForQuerying"
																		},
																		"id": 1738,
																		"name": "Identifier",
																		"src": "2320:25:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 1739,
																		"name": "Literal",
																		"src": "2349:1:5"
																	}
																],
																"id": 1740,
																"name": "BinaryOperation",
																"src": "2320:30:5"
															}
														],
														"id": 1741,
														"name": "BinaryOperation",
														"src": "2287:63:5"
													}
												],
												"id": 1742,
												"name": "FunctionCall",
												"src": "2279:72:5"
											}
										],
										"id": 1743,
										"name": "ExpressionStatement",
										"src": "2279:72:5"
									},
									{
										"attributes": {
											"assignments": [
												null
											],
											"initialValue": null
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "arrayPosting",
													"scope": 1827,
													"stateVariable": false,
													"storageLocation": "memory",
													"type": "address[] memory",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"length": null,
															"type": "address[] storage pointer"
														},
														"children": [
															{
																"attributes": {
																	"name": "address",
																	"type": "address"
																},
																"id": 1745,
																"name": "ElementaryTypeName",
																"src": "2361:7:5"
															}
														],
														"id": 1746,
														"name": "ArrayTypeName",
														"src": "2361:10:5"
													}
												],
												"id": 1747,
												"name": "VariableDeclaration",
												"src": "2361:30:5"
											}
										],
										"id": 1748,
										"name": "VariableDeclarationStatement",
										"src": "2361:30:5"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address[] memory"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1747,
															"type": "address[] memory",
															"value": "arrayPosting"
														},
														"id": 1749,
														"name": "Identifier",
														"src": "2401:12:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "address[] storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1602,
																	"type": "mapping(bytes32 => address[] storage ref)",
																	"value": "retrievePosting"
																},
																"id": 1750,
																"name": "Identifier",
																"src": "2416:15:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1731,
																	"type": "bytes32",
																	"value": "postingDetails"
																},
																"id": 1751,
																"name": "Identifier",
																"src": "2432:14:5"
															}
														],
														"id": 1752,
														"name": "IndexAccess",
														"src": "2416:31:5"
													}
												],
												"id": 1753,
												"name": "Assignment",
												"src": "2401:46:5"
											}
										],
										"id": 1754,
										"name": "ExpressionStatement",
										"src": "2401:46:5"
									},
									{
										"attributes": {
											"assignments": [
												1756
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "length",
													"scope": 1827,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint256",
															"type": "uint256"
														},
														"id": 1755,
														"name": "ElementaryTypeName",
														"src": "2457:7:5"
													}
												],
												"id": 1756,
												"name": "VariableDeclaration",
												"src": "2457:14:5"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"member_name": "length",
													"referencedDeclaration": null,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1747,
															"type": "address[] memory",
															"value": "arrayPosting"
														},
														"id": 1757,
														"name": "Identifier",
														"src": "2474:12:5"
													}
												],
												"id": 1758,
												"name": "MemberAccess",
												"src": "2474:19:5"
											}
										],
										"id": 1759,
										"name": "VariableDeclarationStatement",
										"src": "2457:36:5"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "==",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1756,
															"type": "uint256",
															"value": "length"
														},
														"id": 1760,
														"name": "Identifier",
														"src": "2585:6:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 1761,
														"name": "Literal",
														"src": "2595:1:5"
													}
												],
												"id": 1762,
												"name": "BinaryOperation",
												"src": "2585:11:5"
											},
											{
												"children": [
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "bool",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "transferFrom",
																			"referencedDeclaration": 442,
																			"type": "function (address,address,uint256) external returns (bool)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1588,
																					"type": "contract EchoLinkToken",
																					"value": "objEchoLink"
																				},
																				"id": 1763,
																				"name": "Identifier",
																				"src": "2611:11:5"
																			}
																		],
																		"id": 1765,
																		"name": "MemberAccess",
																		"src": "2611:24:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "sender",
																			"referencedDeclaration": null,
																			"type": "address"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1974,
																					"type": "msg",
																					"value": "msg"
																				},
																				"id": 1766,
																				"name": "Identifier",
																				"src": "2636:3:5"
																			}
																		],
																		"id": 1767,
																		"name": "MemberAccess",
																		"src": "2636:10:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1586,
																			"type": "address",
																			"value": "echoLinkFoundation"
																		},
																		"id": 1768,
																		"name": "Identifier",
																		"src": "2648:18:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1610,
																			"type": "uint256",
																			"value": "amountOfTokensForQuerying"
																		},
																		"id": 1769,
																		"name": "Identifier",
																		"src": "2668:25:5"
																	}
																],
																"id": 1770,
																"name": "FunctionCall",
																"src": "2611:83:5"
															}
														],
														"id": 1771,
														"name": "ExpressionStatement",
														"src": "2611:83:5"
													}
												],
												"id": 1772,
												"name": "Block",
												"src": "2597:121:5"
											},
											{
												"children": [
													{
														"attributes": {
															"assignments": [
																1774
															]
														},
														"children": [
															{
																"attributes": {
																	"constant": false,
																	"name": "amountTokenPay",
																	"scope": 1827,
																	"stateVariable": false,
																	"storageLocation": "default",
																	"type": "uint256",
																	"value": null,
																	"visibility": "internal"
																},
																"children": [
																	{
																		"attributes": {
																			"name": "uint256",
																			"type": "uint256"
																		},
																		"id": 1773,
																		"name": "ElementaryTypeName",
																		"src": "2813:7:5"
																	}
																],
																"id": 1774,
																"name": "VariableDeclaration",
																"src": "2813:22:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "/",
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1610,
																			"type": "uint256",
																			"value": "amountOfTokensForQuerying"
																		},
																		"id": 1775,
																		"name": "Identifier",
																		"src": "2838:25:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "32",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 2",
																			"value": "2"
																		},
																		"id": 1776,
																		"name": "Literal",
																		"src": "2866:1:5"
																	}
																],
																"id": 1777,
																"name": "BinaryOperation",
																"src": "2838:29:5"
															}
														],
														"id": 1778,
														"name": "VariableDeclarationStatement",
														"src": "2813:54:5"
													},
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "bool",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "transferFrom",
																			"referencedDeclaration": 442,
																			"type": "function (address,address,uint256) external returns (bool)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1588,
																					"type": "contract EchoLinkToken",
																					"value": "objEchoLink"
																				},
																				"id": 1779,
																				"name": "Identifier",
																				"src": "2881:11:5"
																			}
																		],
																		"id": 1781,
																		"name": "MemberAccess",
																		"src": "2881:24:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "sender",
																			"referencedDeclaration": null,
																			"type": "address"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1974,
																					"type": "msg",
																					"value": "msg"
																				},
																				"id": 1782,
																				"name": "Identifier",
																				"src": "2906:3:5"
																			}
																		],
																		"id": 1783,
																		"name": "MemberAccess",
																		"src": "2906:10:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1586,
																			"type": "address",
																			"value": "echoLinkFoundation"
																		},
																		"id": 1784,
																		"name": "Identifier",
																		"src": "2918:18:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1774,
																			"type": "uint256",
																			"value": "amountTokenPay"
																		},
																		"id": 1785,
																		"name": "Identifier",
																		"src": "2938:14:5"
																	}
																],
																"id": 1786,
																"name": "FunctionCall",
																"src": "2881:72:5"
															}
														],
														"id": 1787,
														"name": "ExpressionStatement",
														"src": "2881:72:5"
													},
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": true,
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1606,
																					"type": "mapping(address => bool)",
																					"value": "postingSet"
																				},
																				"id": 1788,
																				"name": "Identifier",
																				"src": "2967:10:5"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "sender",
																					"referencedDeclaration": null,
																					"type": "address"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1974,
																							"type": "msg",
																							"value": "msg"
																						},
																						"id": 1789,
																						"name": "Identifier",
																						"src": "2978:3:5"
																					}
																				],
																				"id": 1790,
																				"name": "MemberAccess",
																				"src": "2978:10:5"
																			}
																		],
																		"id": 1791,
																		"name": "IndexAccess",
																		"src": "2967:22:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "74727565",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "bool",
																			"type": "bool",
																			"value": "true"
																		},
																		"id": 1792,
																		"name": "Literal",
																		"src": "2992:4:5"
																	}
																],
																"id": 1793,
																"name": "Assignment",
																"src": "2967:29:5"
															}
														],
														"id": 1794,
														"name": "ExpressionStatement",
														"src": "2967:29:5"
													},
													{
														"attributes": {
															"assignments": [
																1796
															]
														},
														"children": [
															{
																"attributes": {
																	"constant": false,
																	"name": "equalToken",
																	"scope": 1827,
																	"stateVariable": false,
																	"storageLocation": "default",
																	"type": "uint256",
																	"value": null,
																	"visibility": "internal"
																},
																"children": [
																	{
																		"attributes": {
																			"name": "uint256",
																			"type": "uint256"
																		},
																		"id": 1795,
																		"name": "ElementaryTypeName",
																		"src": "3077:7:5"
																	}
																],
																"id": 1796,
																"name": "VariableDeclaration",
																"src": "3077:18:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "/",
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1774,
																			"type": "uint256",
																			"value": "amountTokenPay"
																		},
																		"id": 1797,
																		"name": "Identifier",
																		"src": "3098:14:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1756,
																			"type": "uint256",
																			"value": "length"
																		},
																		"id": 1798,
																		"name": "Identifier",
																		"src": "3113:6:5"
																	}
																],
																"id": 1799,
																"name": "BinaryOperation",
																"src": "3098:21:5"
															}
														],
														"id": 1800,
														"name": "VariableDeclarationStatement",
														"src": "3077:42:5"
													},
													{
														"children": [
															{
																"attributes": {
																	"assignments": [
																		1802
																	]
																},
																"children": [
																	{
																		"attributes": {
																			"constant": false,
																			"name": "j",
																			"scope": 1827,
																			"stateVariable": false,
																			"storageLocation": "default",
																			"type": "uint256",
																			"value": null,
																			"visibility": "internal"
																		},
																		"children": [
																			{
																				"attributes": {
																					"name": "uint256",
																					"type": "uint256"
																				},
																				"id": 1801,
																				"name": "ElementaryTypeName",
																				"src": "3184:7:5"
																			}
																		],
																		"id": 1802,
																		"name": "VariableDeclaration",
																		"src": "3184:9:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 1803,
																		"name": "Literal",
																		"src": "3194:1:5"
																	}
																],
																"id": 1804,
																"name": "VariableDeclarationStatement",
																"src": "3184:11:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "<",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1802,
																			"type": "uint256",
																			"value": "j"
																		},
																		"id": 1805,
																		"name": "Identifier",
																		"src": "3197:1:5"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1756,
																			"type": "uint256",
																			"value": "length"
																		},
																		"id": 1806,
																		"name": "Identifier",
																		"src": "3201:6:5"
																	}
																],
																"id": 1807,
																"name": "BinaryOperation",
																"src": "3197:10:5"
															},
															{
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"operator": "++",
																			"prefix": false,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1802,
																					"type": "uint256",
																					"value": "j"
																				},
																				"id": 1808,
																				"name": "Identifier",
																				"src": "3209:1:5"
																			}
																		],
																		"id": 1809,
																		"name": "UnaryOperation",
																		"src": "3209:3:5"
																	}
																],
																"id": 1810,
																"name": "ExpressionStatement",
																"src": "3209:3:5"
															},
															{
																"children": [
																	{
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"isStructConstructorCall": false,
																					"lValueRequested": false,
																					"names": [
																						null
																					],
																					"type": "bool",
																					"type_conversion": false
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": [
																								{
																									"typeIdentifier": "t_address",
																									"typeString": "address"
																								},
																								{
																									"typeIdentifier": "t_address",
																									"typeString": "address"
																								},
																								{
																									"typeIdentifier": "t_uint256",
																									"typeString": "uint256"
																								}
																							],
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "transferFrom",
																							"referencedDeclaration": 442,
																							"type": "function (address,address,uint256) external returns (bool)"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1588,
																									"type": "contract EchoLinkToken",
																									"value": "objEchoLink"
																								},
																								"id": 1811,
																								"name": "Identifier",
																								"src": "3231:11:5"
																							}
																						],
																						"id": 1813,
																						"name": "MemberAccess",
																						"src": "3231:24:5"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "sender",
																							"referencedDeclaration": null,
																							"type": "address"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1974,
																									"type": "msg",
																									"value": "msg"
																								},
																								"id": 1814,
																								"name": "Identifier",
																								"src": "3256:3:5"
																							}
																						],
																						"id": 1815,
																						"name": "MemberAccess",
																						"src": "3256:10:5"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": false,
																							"type": "address"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1747,
																									"type": "address[] memory",
																									"value": "arrayPosting"
																								},
																								"id": 1816,
																								"name": "Identifier",
																								"src": "3268:12:5"
																							},
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1802,
																									"type": "uint256",
																									"value": "j"
																								},
																								"id": 1817,
																								"name": "Identifier",
																								"src": "3281:1:5"
																							}
																						],
																						"id": 1818,
																						"name": "IndexAccess",
																						"src": "3268:15:5"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1796,
																							"type": "uint256",
																							"value": "equalToken"
																						},
																						"id": 1819,
																						"name": "Identifier",
																						"src": "3285:10:5"
																					}
																				],
																				"id": 1820,
																				"name": "FunctionCall",
																				"src": "3231:65:5"
																			}
																		],
																		"id": 1821,
																		"name": "ExpressionStatement",
																		"src": "3231:65:5"
																	}
																],
																"id": 1822,
																"name": "Block",
																"src": "3213:98:5"
															}
														],
														"id": 1823,
														"name": "ForStatement",
														"src": "3180:131:5"
													}
												],
												"id": 1824,
												"name": "Block",
												"src": "2799:522:5"
											}
										],
										"id": 1825,
										"name": "IfStatement",
										"src": "2582:739:5"
									}
								],
								"id": 1826,
								"name": "Block",
								"src": "2269:1058:5"
							}
						],
						"id": 1827,
						"name": "FunctionDefinition",
						"src": "2217:1110:5"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getPostingWhenTrue",
							"payable": false,
							"scope": 1867,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_postingDetails",
											"scope": 1848,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 1828,
												"name": "ElementaryTypeName",
												"src": "3365:7:5"
											}
										],
										"id": 1829,
										"name": "VariableDeclaration",
										"src": "3365:23:5"
									}
								],
								"id": 1830,
								"name": "ParameterList",
								"src": "3364:25:5"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "",
											"scope": 1848,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address[] memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"length": null,
													"type": "address[] storage pointer"
												},
												"children": [
													{
														"attributes": {
															"name": "address",
															"type": "address"
														},
														"id": 1831,
														"name": "ElementaryTypeName",
														"src": "3410:7:5"
													}
												],
												"id": 1832,
												"name": "ArrayTypeName",
												"src": "3410:9:5"
											}
										],
										"id": 1833,
										"name": "VariableDeclaration",
										"src": "3410:9:5"
									}
								],
								"id": 1834,
								"name": "ParameterList",
								"src": "3409:11:5"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1835,
														"name": "Identifier",
														"src": "3430:7:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1606,
																	"type": "mapping(address => bool)",
																	"value": "postingSet"
																},
																"id": 1836,
																"name": "Identifier",
																"src": "3438:10:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1974,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 1837,
																		"name": "Identifier",
																		"src": "3449:3:5"
																	}
																],
																"id": 1838,
																"name": "MemberAccess",
																"src": "3449:10:5"
															}
														],
														"id": 1839,
														"name": "IndexAccess",
														"src": "3438:22:5"
													}
												],
												"id": 1840,
												"name": "FunctionCall",
												"src": "3430:31:5"
											}
										],
										"id": 1841,
										"name": "ExpressionStatement",
										"src": "3430:31:5"
									},
									{
										"attributes": {
											"functionReturnParameters": 1834
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"type": "address[] storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "address[] storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1602,
																	"type": "mapping(bytes32 => address[] storage ref)",
																	"value": "retrievePosting"
																},
																"id": 1842,
																"name": "Identifier",
																"src": "3478:15:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1829,
																	"type": "bytes32",
																	"value": "_postingDetails"
																},
																"id": 1843,
																"name": "Identifier",
																"src": "3494:15:5"
															}
														],
														"id": 1844,
														"name": "IndexAccess",
														"src": "3478:32:5"
													}
												],
												"id": 1845,
												"name": "TupleExpression",
												"src": "3477:34:5"
											}
										],
										"id": 1846,
										"name": "Return",
										"src": "3471:40:5"
									}
								],
								"id": 1847,
								"name": "Block",
								"src": "3420:98:5"
							}
						],
						"id": 1848,
						"name": "FunctionDefinition",
						"src": "3337:181:5"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "postingSetToFalse",
							"payable": false,
							"scope": 1867,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1849,
								"name": "ParameterList",
								"src": "3550:2:5"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1850,
								"name": "ParameterList",
								"src": "3560:0:5"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1851,
														"name": "Identifier",
														"src": "3570:7:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1606,
																	"type": "mapping(address => bool)",
																	"value": "postingSet"
																},
																"id": 1852,
																"name": "Identifier",
																"src": "3578:10:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1974,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 1853,
																		"name": "Identifier",
																		"src": "3589:3:5"
																	}
																],
																"id": 1854,
																"name": "MemberAccess",
																"src": "3589:10:5"
															}
														],
														"id": 1855,
														"name": "IndexAccess",
														"src": "3578:22:5"
													}
												],
												"id": 1856,
												"name": "FunctionCall",
												"src": "3570:31:5"
											}
										],
										"id": 1857,
										"name": "ExpressionStatement",
										"src": "3570:31:5"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1606,
																	"type": "mapping(address => bool)",
																	"value": "postingSet"
																},
																"id": 1858,
																"name": "Identifier",
																"src": "3611:10:5"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1974,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 1859,
																		"name": "Identifier",
																		"src": "3622:3:5"
																	}
																],
																"id": 1860,
																"name": "MemberAccess",
																"src": "3622:10:5"
															}
														],
														"id": 1861,
														"name": "IndexAccess",
														"src": "3611:22:5"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "66616c7365",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "bool",
															"type": "bool",
															"value": "false"
														},
														"id": 1862,
														"name": "Literal",
														"src": "3636:5:5"
													}
												],
												"id": 1863,
												"name": "Assignment",
												"src": "3611:30:5"
											}
										],
										"id": 1864,
										"name": "ExpressionStatement",
										"src": "3611:30:5"
									}
								],
								"id": 1865,
								"name": "Block",
								"src": "3560:88:5"
							}
						],
						"id": 1866,
						"name": "FunctionDefinition",
						"src": "3524:124:5"
					}
				],
				"id": 1867,
				"name": "ContractDefinition",
				"src": "106:3545:5"
			}
		],
		"id": 1868,
		"name": "SourceUnit",
		"src": "0:3651:5"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.18+commit.9cf6e910.Emscripten.clang"
	},
	"networks": {
		"4": {
			"events": {},
			"links": {},
			"address": "0xc4621a096ede7c97ce7e90d3940385cba040b9f1"
		}
	},
	"schemaVersion": "1.0.1",
	"updatedAt": "2018-02-22T12:09:06.977Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/PostingStore.json
// module id = 73
// module chunks = 0